import { customColumnProps } from "@maherunlocker/custom-react-table";
import React from "react";
import { useTranslation } from "react-i18next";
import { DisplayName } from "../DisplayName";
import { CustomIcons } from "./CustomIcons";

export function ArrayOfCustomColumns({
    setDataState,
    isArchivedLanguagesClicked,
    modalState,
    setModalState,
    tableState,
    setTableState,
}: any): customColumnProps[] {
    const { t } = useTranslation();

    return [
        {
            indexOFColumn: 2,
            columnName: t("Language"),
            customJsx: (e: any) => <span>{e.selectedRow[t("Language")]}</span>,
            filterName: t("Language"),
            canFilter: true,
        },
        {
            indexOFColumn: 1,
            columnName: t("Display name"),
            customJsx: (e: any) => <DisplayName e={e} />,
            filterName: "display_name",
            canFilter: true,
        },
        {
            indexOFColumn: 3,
            columnName: t("Country"),
            customJsx: (e: any) => <GetCountry e={e} />,
            filterName: t("Country"),
            canFilter: true,
        },
        {
            indexOFColumn: 7,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setDataState={setDataState}
                    isArchivedLanguagesClicked={isArchivedLanguagesClicked}
                    modalState={modalState}
                    setModalState={setModalState}
                    tableState={tableState}
                    setTableState={setTableState}
                />
            ),
        },
    ];
}
function GetCountry(e: any) {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {e.e.selectedRow?.subRows !== undefined
                ? e.e.selectedRow.country
                : e.e.selectedRow[t("Country")]}
        </React.Fragment>
    );
}
